import router from '../router';

export function errorHandler(err) {
  if (err.status === 401) {
    router.push('/login');
  }
}

export function errorGQLHandler({ graphQLErrors, networkError }) {
  if (graphQLErrors) {
    graphQLErrors.map(({ message, locations, path }) =>
      console.log(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`),
    );
  }

  if (networkError && networkError.response) {
    const { response } = networkError;
    /**
     * Redirect 401
     */
    if (response.status === 401) {
      if (!router.currentRoute.fullPath.match(/\/login/g)) {
        router.push('/login');
      }
    }
  }
}

/**
 *
 * @param compare
 * @param value
 * @returns {boolean}
 */
export const isEqualTo = (compare, value) => compare === value;

export const isNull = value => value === null;

export const isObject = value => typeof value === 'object';

export function getCanal(canal) {
  switch (canal) {
    case 1:
      return 'Administrativo';
    case 3:
      return 'PaP';
    case 5:
      return 'Loja Própria';
    case 6:
      return 'Parceiro';
    case 7:
      return 'Televendas';
    case 8:
      return 'Vivo Prime';
    case 9:
      return 'OVVI';
    default:
      return '';
  }
}

export function currentDateFormat() {
  return anyDateFormat(new Date());
}

export function anyDateFormat(d) {
  if (!d) {
    return '';
  }

  let month = `${d.getMonth() + 1}`;
  let day = `${d.getDate()}`;
  const year = d.getFullYear();

  if (month.length < 2) month = `0${month}`;
  if (day.length < 2) day = `0${day}`;

  return [day, month, year].join('/');
}

export function currentDate() {
  const d = new Date();
  let month = `${d.getMonth() + 1}`;
  let day = `${d.getDate()}`;
  const year = d.getFullYear();

  if (month.length < 2) month = `0${month}`;
  if (day.length < 2) day = `0${day}`;

  return [year, month, day].join('');
}

export function validateUrl(value) {
  return /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i.test(
    value,
  );
}
